/**
 * 云服务类别 产品实例列表 copy实例ID
 *
 * @format
 */

import React, { useEffect } from 'react'
import { _$, Tooltip, Message } from '@king-design/react'
import styled from 'styled-components'
import { useCopyToClipboard } from 'react-use'

interface CloudListTableCopyTipsProps {
  className?: string
  instanceId: string
  margin?: boolean
}

const CloudListTableCopyTips: React.FC<CloudListTableCopyTipsProps> = ({
  className,
  instanceId,
  margin = false
}) => {
  // copy hooks
  const [copyState, copyToClipboard] = useCopyToClipboard()

  // 复制成功/失败后提示
  useEffect(() => {
    const { error, value } = copyState
    if (value) {
      if (error) {
        // Message.error(error)
      } else {
        Message.success(`${_$('复制成功')} ${value}`)
      }
    }
  }, [copyState])

  return (
    <span className={className} style={{ marginLeft: margin ? null : 8 }}>
      <Tooltip
        hoverable
        theme="light"
        position="right"
        slotContent={
          <div style={{ width: 200 }}>
            <span
              style={{
                marginRight: 5,
                marginBottom: 0
              }}
            >
              {instanceId}
            </span>
            <span
              onClick={() => {
                copyToClipboard(instanceId)
              }}
              style={{ color: '#62c3ff', marginBottom: 0, cursor: 'pointer' }}
            >
              {_$('复制ID')}
            </span>
          </div>
        }
      >
        <p className="id-tips cursor-pointer">ID</p>
      </Tooltip>
    </span>
  )
}

export default styled(CloudListTableCopyTips)`
  .id-tips {
    display: inline-block;
    margin-bottom: 0;
    width: 14px;
    height: 14px;
    line-height: 14px;
    background: #0091ea;
    text-align: center;
    font-size: 12px;
    color: #fff;
  }
`
